import React from 'react'
import { ucFirst } from '../../../helpers/string_helper'
import { ActivityModule, Modules } from '../../../constants/Module'
import { Action } from '../../../constants/Common'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { withTranslation } from 'react-i18next'
function PortfolioProject({item, t}) {
  return (
    <div>
    <strong>{t('The startup')} {item?.payload?.project?.name} {item?.payload?.project?.uniqueProjectId ? `(${item?.payload?.project?.uniqueProjectId})`: ''} </strong>
     {item.event === Action.CREATE ? t('was added to') : t('was removed from')} <strong> {t('portfolio')} ({item?.payload?.portfolio?.name} {item?.payload?.portfolio?.uniquePortfolioId ? `| ${item?.payload?.portfolio?.uniquePortfolioId}` : ''})</strong> {t('by')} 
    <CreatorDetails creator={item?.creator} date={item?.createdAt} />
  </div>
  )
}
export default withTranslation()(PortfolioProject)